export class GetBackupJobResponse {
    'job';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "job",
            "baseName": "job",
            "type": "BackupJob",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetBackupJobResponse.attributeTypeMap;
    }
    constructor() {
    }
}
